import _ from "lodash";
import get from "lodash/get";

import { db, firebase } from "astrid-firebase";
import addEvent from "astrid-firebase/src/utils";

const convertMaster = firebase.functions().httpsCallable("convertMaster");

export const estimateTotal = (production) =>
	production &&
	production.stats &&
	production.stats.pages &&
	production.stats.cubase &&
	production.pages &&
	Math.round(production.stats.cubase.total * (production.pages / production.stats.pages.total));

export const addMasterFileToArticle = (productionId, article, fileid, external = false) => {
	db.collection("productions")
		.doc(productionId)
		.set(
			{
				master: {
					[article]: {
						files: firebase.firestore.FieldValue.arrayUnion(fileid),
						settings: { approved: false },
						external,
					},
				},
			},
			{ merge: true },
		);
};

export const queueMasterFileForProcessing = ({
	productionId,
	fileid,
	name,
	path,
	downloadURL,
	uid,
	email,
	unmastered,
	userName,
}) => {
	const data = {
		[fileid]: {
			name,
			original: { path, url: downloadURL },
			status: "queued",
			created: firebase.firestore.FieldValue.serverTimestamp(),
			user: userName,
		},
	};

	if (unmastered) {
		data[fileid].unmastered = true;
	}

	db.collection("productions")
		.doc(productionId)
		.collection("meta")
		.doc("master")
		.set(data, { merge: true })
		.then(() => {
			// start job
			convertMaster({ productionId, masterId: fileid });
		})
		.then(() => {
			// store event
			addEvent({
				productionId,
				user: uid,
				email,
				data,
			});
		})
		.catch((err) => {
			//handle error
			console.log("nextUpload -> err", err);
		});
};

export const getDistOptions = ({ production, publisher }) => {
	const publisherOptions =
		get(publisher, "distributionOptions") &&
		Object.values(publisher.distributionOptions).find(
			(opt) => opt.languages && opt.languages.includes(production.language),
		);

	let mergedOptions = _.cloneDeep(publisherOptions);

	if (mergedOptions && production?.distributionOptions) {
		const productionOptions = production.distributionOptions;
		if (productionOptions.settings) {
			mergedOptions.settings = _.merge({}, publisherOptions.settings, productionOptions.settings);
		}

		const isDisabled = (key, type) => {
			return (
				productionOptions.settings &&
				productionOptions.settings[type] &&
				productionOptions.settings[type][key] &&
				productionOptions.settings[type][key].disabled
			);
		};

		const filterDisabled = (arr, type) => {
			return arr.filter((item) => !isDisabled(item, type));
		};

		mergedOptions.languages = _.union(publisherOptions.languages, productionOptions.languages || []);
		mergedOptions.ebook = filterDisabled(_.union(publisherOptions.ebook, productionOptions.ebook || []), "ebook");
		mergedOptions.total = filterDisabled(_.union(publisherOptions.total, productionOptions.total || []), "total");
		mergedOptions.part = filterDisabled(_.union(publisherOptions.part, productionOptions.part || []), "part");
	}

	return mergedOptions;
};
